import styled from "styled-components/macro"

export const NodesWrapper = styled.div`
  overflow-x: auto;
`
